import { Injectable } from '@angular/core';
import { ENDPOINTS, getUuidV4, OdataService } from '@evorait/pace-core';
import { Observable } from 'rxjs';
import RequestNotificationModel from './request-notification.model';

@Injectable({ providedIn: 'root' })
export class OdataRequestNotificationService {
    public constructor(private readonly odataService: OdataService) {}

    public requestNotification(requestNotificationModel: RequestNotificationModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            requestNotificationModel,
            ENDPOINTS.RequestNotification,
            `${getUuidV4()}`,
        );
    }
}
